import { PART_NAMES, SPECS, YC_PATHS } from "@/lib/doorScene";

const DoorSketch = () => (
  <svg viewBox="0 0 220 260" className="h-full max-h-[300px] w-auto" aria-hidden="true">
    <path d="M40 250 V20 H180 V250" fill="none" stroke="#30302e" strokeWidth="10" />
    <rect x="62" y="34" width="96" height="206" fill="#ff6600" transform="translate(14 6)" />
    <rect x="90" y="62" width="26" height="80" fill="#cbd8d2" stroke="#bec3c0" strokeWidth="2" transform="translate(14 6)" />
    <svg x="135" y="92" width="32" height="32" viewBox="0 0 48 48" data-testid="hero-fallback-yc-logo">
      {YC_PATHS.map(([d, fill]) => <path key={fill} d={d} fill={fill} />)}
    </svg>
    {[60, 130, 205].map((y) => <rect key={y} x="56" y={y} width="8" height="16" fill="#bec3c0" />)}
    <circle cx="160" cy="150" r="5" fill="#bec3c0" />
    <rect x="98" y="16" width="44" height="8" fill="#bec3c0" transform="translate(0 -6)" />
    <rect x="76" y="212" width="96" height="24" fill="#d3d6d4" />
    <rect x="30" y="250" width="160" height="6" fill="#bec3c0" />
  </svg>
);

export const DoorFallback = () => (
  <div className="absolute inset-0 flex flex-col items-center justify-center gap-6 p-6 sm:flex-row sm:gap-10" data-testid="hero-3d-fallback">
    <DoorSketch />
    <ol className="grid grid-cols-1 gap-2 text-left">
      {PART_NAMES.map((n, i) => (
        <li key={n} className="flex items-baseline gap-3 border-l border-[#bdbdb4] pl-3 font-mono text-[11px] uppercase tracking-[0.12em] text-[#292929]">
          <span className="text-[#ff6600]">{String(i + 1).padStart(2, "0")}</span>
          {n}
          <span className="text-[#94948a]">{SPECS[i].sec}</span>
        </li>
      ))}
    </ol>
  </div>
);
